module.exports = __webpack_public_path__ + "static/media/Stretching-man.a88cec26.svg";